jQuery(document).ready(function ($) {

    $('#block-ef2-custom-main-menu li.menu-item a').on('click touchstart', function(event){
        if($(this).parent('li.menu-item').find('ul.menu').length){
            $('#block-ef2-custom-main-menu ul li.active').not($(this).parents('li.menu-item')).removeClass('active');
            $('#block-ef2-custom-main-menu ul li.active, #block-ef2-custom-main-menu ul li.menu-item--active-trail').removeClass('menu-item--active-trail');
            // $('#block-ef2-custom-main-menu ul li.active, #block-ef2-custom-main-menu ul li.menu-item--active-trail').not($(this).parents('li.menu-item')).toggleClass('old-active');
            $(this).closest('li.menu-item').toggleClass('active');
            $('body').toggleClass('sub-menu-item-active');
            event.preventDefault();
            event.stopPropagation();
        }
    });

    $('#menu-toggle').on('click touchstart', function(event){
        event.stopImmediatePropagation();
        event.preventDefault();
        $(this).toggleClass('active');
        $('#navbar').toggleClass('menu-open');
        $('body').toggleClass('main-menu-active');
        $('#block-ef2-custom-main-menu ul.menu li').removeClass('active old-active');
    });

    $('#block-ef2-custom-main-menu ul.menu li .submenu-wrapper .menu-back-link').on('click touchstart', function(event){      
        $(this).closest('li.menu-item--expanded').removeClass('active');
        event.preventDefault();
        event.stopPropagation();
    });

    $('body').on('click touchstart', function(event){
        if (!$(event.target).closest('#navbar').length) {
            $('#navbar').removeClass('menu-open');
            $('body').removeClass('sub-menu-item-active');
            $('#block-ef2-custom-main-menu ul.menu li').removeClass('active');
            $('#block-ef2-custom-main-menu ul.menu li').removeClass('old-active');
            $('#menu-toggle').removeClass('active');
        }
    });

    $(".scrollto-wrapper a.scrollto").click(function() {
        event.preventDefault();
        event.stopPropagation();
        var targetDiv = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(targetDiv).offset().top
        }, 500);
    });

});